import * as Yup from "yup";
import { mockAttendanceAchievements } from './attendanceMocks';

export const gamificationSchema = Yup.object().shape({
    // Frequência - Membro (Member)
    memberAttendancePresent: Yup.number().integer().required("A pontuação de presença do aluno é obrigatória").default(1),
    memberAttendanceExcused: Yup.number().integer().required("A pontuação de falta justificada do aluno é obrigatória").default(1),
    memberAttendanceUnexcused: Yup.number().integer().required("A pontuação de falta injustificada do aluno é obrigatória").default(0),

    // Frequência - Professor
    teacherAttendancePresent: Yup.number().integer().required("A pontuação de presença do professor é obrigatória").default(1),
    teacherAttendanceExcused: Yup.number().integer().required("A pontuação de falta justificada do professor é obrigatória").default(1),
    teacherAttendanceUnexcused: Yup.number().integer().required("A pontuação de falta injustificada do professor é obrigatória").default(0),

    // Sistema de Avaliação (Passagem de Nível)
    minScoreToPassPercent: Yup.number()
        .min(0, "Mínimo é 0%")
        .max(100, "Máximo é 100%")
        .required("A nota mínima para aprovação é obrigatória")
        .default(70),
    requireFundamentalsMaxScore: Yup.boolean().default(true),
    xpRewardMemberPass: Yup.number().integer().min(0).required("A recompensa XP para o aluno é obrigatória").default(50),
    xpRewardTeacherPass: Yup.number().integer().min(0).required("A recompensa XP para o professor é obrigatória").default(25),

    // Outras formas de pontuação (Geral / Somatória / Streaks)
    rankingCalculationStrategy: Yup.string().required("A estratégia de cálculo do ranking é obrigatória").default('sum_all'),
    attendanceStreakRequired: Yup.number().integer().min(0).required("A quantidade de presenças para o bônus de sequência é obrigatória").default(0),
    attendanceStreakBonusXp: Yup.number().integer().min(0).required("O bônus de XP por sequência é obrigatório").default(0),

    // Conquistas & Insígnias (Achievements & Badges)
    achievements: Yup.array().of(
        Yup.object().shape({
            id: Yup.string().required(),
            name: Yup.string().required("O nome da Insígnia é obrigatório"),
            description: Yup.string(),
            type: Yup.string().oneOf(['points', 'attendance', 'streak']).required("O tipo é obrigatório"),
            threshold: Yup.number().integer().min(1, "O requisito deve ser maior ou igual a 1").required("O objetivo numérico é obrigatório"),
            icon: Yup.string().required("O ícone é obrigatório"),
            rewardXp: Yup.number().integer().min(0).default(0)
        })
    ).default(() => mockAttendanceAchievements),

    // Níveis de Gamificação (Ranks)
    levelRanks: Yup.array().of(
        Yup.object().shape({
            id: Yup.string().required(),
            name: Yup.string().required("O nome do Nível é obrigatório"),
            minXp: Yup.number().integer().min(0, "A pontuação mínima deve ser maior ou igual a 0").required("A pontuação mínima é obrigatória"),
            imageId: Yup.string()
        })
    ).default(() => Array.from({ length: 20 }).map((_, i) => ({
        id: `rank_${i + 1}`,
        name: `Nível ${i + 1}`,
        minXp: i === 0 ? 0 : i * 100,
        imageId: `rank_${i + 1}`
    })))
});
